"use client";

import { useEffect, useState, useCallback } from "react";
import Image from "next/image";

type ModalPromoProps = {
  src?: string;
  href?: string;
};

export default function ModalPromo({
  src = "/images/promo.webp",
  href = "https://google.com",
}: ModalPromoProps) {
  const [open, setOpen] = useState(false);

  // langsung buka setiap render pertama kali
  useEffect(() => {
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  // tutup pakai ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, close]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Promo"
      className="fixed inset-0 z-50 flex items-center justify-center"
    >
      {/* backdrop */}
      <button
        aria-label="Close promo"
        onClick={close}
        className="absolute inset-0 w-full h-full bg-black/60"
      />
      {/* modal card */}
      <div className="relative w-[95vw] max-w-[900px] rounded-2xl bg-black/20 p-2 overflow-hidden">

        {/* tombol close */}
        <button
          onClick={close}
          className="absolute right-3 top-3 rounded-full px-2 py-1 text-sm bg-black/70 text-white hover:bg-black/90"
        >
          ✕
        </button>

        {/* gambar link */}
        <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Buka promo">
          <Image
            src={src}
            alt="Promo"
            width={1800}
            height={1200}
            className="w-full h-auto select-none"
            priority
          />
        </a>
      </div>
    </div>
  );
}
